import { Badge } from "react-bootstrap";

export const STATUS = {
  draft: { label: "Draft", bg: "secondary", text: "light" },
  in_review: { label: "In review", bg: "warning", text: "dark" },
  pending: { label: "Pending approval", bg: "info", text: "dark" },
  approved: { label: "Approved", bg: "success", text: "light" },
  paid: { label: "Paid", bg: "dark", text: "light" },
  declined: { label: "Declined", bg: "danger", text: "light" },
  rejected: { label: "Declined", bg: "danger", text: "light" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] ?? STATUS.pending;
  return (
    <Badge pill bg={s.bg} text={s.text} className="fw-normal status-badge">
      {s.label}
    </Badge>
  );
}
